import "Enum.js";
NS("Security");

Security.AccessMode = Static(Enum, {
    Read: 1,
    Insert: 2,
    Update: 3,
    Remove: 4,
    Execute: 5,
    View: 6
});
